/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Per-organization device integration config for one provider. Secret credentials are write-only; reads only expose whether credentials are configured.
 */
export type DeviceIntegrationConfig = {
  /**
   * ISO 8601 timestamp when the config was created. Omitted when no config is set.
   */
  createdAt?: Date | undefined;
  /**
   * Whether the provider integration is active.
   */
  enabled: boolean;
  /**
   * Whether secret credentials are currently stored. The values themselves are never returned.
   */
  hasCredentials: boolean;
  /**
   * Config ID. Omitted when no config is set for the provider.
   */
  id?: string | undefined;
  /**
   * Organization the config belongs to.
   */
  organizationId: string;
  /**
   * Provider identifier (e.g. jamf, kandji, drata, vanta).
   */
  provider: string;
  /**
   * Non-secret provider settings (e.g. instance URL), keyed by field key.
   */
  settings: { [k: string]: string };
  /**
   * ISO 8601 timestamp of the most recent change. Omitted when no config is set.
   */
  updatedAt?: Date | undefined;
};

/** @internal */
export const DeviceIntegrationConfig$inboundSchema: z.ZodMiniType<
  DeviceIntegrationConfig,
  unknown
> = z.pipe(
  z.object({
    created_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    enabled: z.boolean(),
    has_credentials: z.boolean(),
    id: z.optional(z.string()),
    organization_id: z.string(),
    provider: z.string(),
    settings: z.record(z.string(), z.string()),
    updated_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "has_credentials": "hasCredentials",
      "organization_id": "organizationId",
      "updated_at": "updatedAt",
    });
  }),
);

export function deviceIntegrationConfigFromJSON(
  jsonString: string,
): SafeParseResult<DeviceIntegrationConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeviceIntegrationConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeviceIntegrationConfig' from JSON`,
  );
}
